import type { ScopeRegistry } from '@shared/lib/scope'

import { useDisciplineStore } from '@entities/customer'

import { DEFAULT_SCOPE_REQUIRES, SCOPE_SOURCES } from './sources'

export const scopeRegistry: ScopeRegistry = {
  sources: SCOPE_SOURCES,
  defaultRequires: DEFAULT_SCOPE_REQUIRES,
  activeDisciplineId: () => useDisciplineStore().activeDiscipline?.id ?? null,
}
